export default function EFWashingMachine(props: any) {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_35_9869)">
                <path
                    d="M30.4465 34.2451H9.55368C8.66608 34.2451 7.94653 33.5256 7.94653 32.638V6.92369C7.94653 6.03609 8.66608 5.31655 9.55368 5.31655H30.4465C31.3341 5.31655 32.0537 6.03609 32.0537 6.92369V32.638C32.0537 33.5256 31.3341 34.2451 30.4465 34.2451Z"
                    stroke="#707070"
                    strokeWidth="1.60714"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M7.94653 27.0127H32.0537" stroke="#707070" strokeWidth="1.60714" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M24.8215 30.6289H28.4376" stroke="#707070" strokeWidth="1.60714" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="1.20536" cy="1.20536" r="1.20536" transform="matrix(1 0 0 -1 10.3573 31.834)" fill="#707070" />
                <circle cx="1.20536" cy="1.20536" r="1.20536" transform="matrix(1 0 0 -1 13.9733 31.834)" fill="#707070" />
                <circle cx="1.20536" cy="1.20536" r="1.20536" transform="matrix(1 0 0 -1 17.5894 31.834)" fill="#707070" />
                <circle cx="7.23214" cy="7.23214" r="7.23214" transform="matrix(1 0 0 -1 12.768 23.3965)" stroke="#707070" strokeWidth="1.60714" />
            </g>
            <defs>
                <clipPath id="clip0_35_9869">
                    <rect width="38.5714" height="38.5714" fill="white" transform="translate(0.714417 0.495117)" />
                </clipPath>
            </defs>
        </svg>
    );
}
